import { ServiceModalPageModule } from "./pages/service-modal/service-modal.module";
import { VoucherService } from "./services/voucher/voucher.service";
import { SeoService } from "./services/seo/seo.service";
import { SettingsService } from "./services/settings/settings.service";
import { FcmService } from "./services/fcm/fcm.service";
import { TabsModule } from "ngx-bootstrap/tabs";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule, Title } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { environment } from "../environments/environment";
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FavouritesService } from "./services/favourites/favourites.service";
import { NgbDatepickerModule, NgbDropdownModule, NgbModule} from "@ng-bootstrap/ng-bootstrap";
import { CartService } from "./services/cart/cart.service";
import { ApiServiceProvider } from "./services/api/api.service.provider";
import { EnvironmentServiceProvider } from "./services/environment/environment.service.provider";

import { CategoriesService } from "./services/categories/categories.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { TokenInterceptor } from "./interceptors/token.interceptor";
import { AppInitializerService } from "./services/app-initializer/app-initializer.service";
import { IonicStorageModule } from '@ionic/storage-angular';

export function initializeApp(appInitializerService: AppInitializerService) {
  return () => appInitializerService.initializeApp();
}

let imports = [
  BrowserModule,
  IonicModule.forRoot({
    innerHTMLTemplatesEnabled: true
  }),
  AppRoutingModule,
  SharedModule,

  BrowserAnimationsModule,
  NgbDatepickerModule,
  NgbModule,
  TabsModule.forRoot(),
  NgbDropdownModule,
  HttpClientModule,
  ServiceModalPageModule,
  IonicStorageModule.forRoot({      
    name: environment.storage_name ?? 'becreative.communitysportsarenas',
  }),
];

const mobileOnlyImports = [];
const webOnlyImports = [];

if (window["__env"].platform === "mobile") {
  mobileOnlyImports.forEach((val) => {
    imports.push(val);
  });
}

if (window["__env"].platform === "web") {
  webOnlyImports.forEach((val) => {
    imports.push(val);
  });
}

@NgModule({
    declarations: [AppComponent],
    imports: [
      BrowserModule,
      IonicModule.forRoot({
        innerHTMLTemplatesEnabled: true
      }),
      AppRoutingModule,
      SharedModule,
      BrowserAnimationsModule,
      NgbDatepickerModule,
      NgbModule,
      TabsModule.forRoot(),
      NgbDropdownModule,
      ServiceModalPageModule,
      IonicStorageModule.forRoot({      
        name: environment.storage_name ?? 'becreative.communitysportsarenas',
      }),
      ...mobileOnlyImports,
      ...webOnlyImports
    ],
    providers: [
        { 
          provide: RouteReuseStrategy,
          useClass: IonicRouteStrategy
        },
        {
          provide: APP_INITIALIZER,
          useFactory: initializeApp,
          deps: [AppInitializerService],
          multi: true,
        },
        EnvironmentServiceProvider,
        ApiServiceProvider,
        CartService,
        FavouritesService,
        SettingsService,
        Title,
        SeoService,
        VoucherService,
        FcmService,
        CategoriesService,
        // Removed raw 'ScreenOrientation' class entry to fix NG1010 value extraction error
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}


